import { mapFriendlyVisitsAtom } from '@/components/mapping/VisitsMap/VisitsMap.atoms';
import { MapFriendlyVisit } from '@/components/mapping/VisitsMap/VisitsMap.types';
import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagEnabled } from '@/utils/useFeatureFlagEnabled';
import { useSetAtom } from 'jotai';
import { useLayoutEffect, useMemo } from 'react';

export const useSetMapFriendlyVisits = (setter: () => MapFriendlyVisit[]) => {
    const hasVisitsMap = useFeatureFlagEnabled(FeatureFlag.ALL_VISITS_MAP);
    const setMapFriendlyVisits = useSetAtom(mapFriendlyVisitsAtom);

    const mapFriendlyVisits: MapFriendlyVisit[] = useMemo(() => {
        // If no access to map, don't waste compute
        if (!hasVisitsMap) {
            return [];
        }
        return setter();
    }, [hasVisitsMap, setter]);

    useLayoutEffect(() => {
        setMapFriendlyVisits(mapFriendlyVisits);
    }, [setMapFriendlyVisits, mapFriendlyVisits]);
};
